import { takeLatest, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { jobEditData } from './slice'
import { jobAPI } from '../../../api'
import { RequestUtils } from 'utils'

function* getData({ payload: { id, params = {} } }) {
  try {
    let requestParams = {
      includes: [
        'jobType',
        'profileExperienceYear',
        'languages',
        'skills',
        'locationCity',
        'locationProvince',
        'profileStudyProgram',
        'profileStudyArea',
        'profileCertifications',
      ],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(jobAPI.getJob, id, requestParams)

    const { data } = response

    yield put(jobEditData.getDataSuccess(data))
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(jobEditData.getDataError(message))
  }
}

function* watchGetData() {
  yield takeLatest(jobEditData.getData, getData)
}

export function* dataSaga() {
  yield all([fork(watchGetData)])
}
